import { render, staticRenderFns } from "./TepDashboardInternoIndex.vue?vue&type=template&id=625b56c2"
import script from "./TepDashboardInternoIndex.vue?vue&type=script&lang=js"
export * from "./TepDashboardInternoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports